import React from "react";

export const NotificationEnabledIcon = (props) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="5" cy="5" r="5" fill="#5A8028" />
  </svg>
);

export const NotificationDisabledIcon = (props) => (
    <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="5" cy="5" r="5" fill="#808080" />
  </svg>
);
 
export const InformationIcon = (props) =>(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_65794_8197)">
<path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z" fill="#303030"/>
</g>
<defs>
<clipPath id="clip0_65794_8197">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

);
export const VideoIcon =()=>(
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00016 14.6663C4.31816 14.6663 1.3335 11.6817 1.3335 7.99967C1.3335 4.31767 4.31816 1.33301 8.00016 1.33301C11.6822 1.33301 14.6668 4.31767 14.6668 7.99967C14.6668 11.6817 11.6822 14.6663 8.00016 14.6663ZM8.00016 13.333C9.41465 13.333 10.7712 12.7711 11.7714 11.7709C12.7716 10.7707 13.3335 9.41416 13.3335 7.99967C13.3335 6.58519 12.7716 5.22863 11.7714 4.22844C10.7712 3.22824 9.41465 2.66634 8.00016 2.66634C6.58567 2.66634 5.22912 3.22824 4.22893 4.22844C3.22873 5.22863 2.66683 6.58519 2.66683 7.99967C2.66683 9.41416 3.22873 10.7707 4.22893 11.7709C5.22912 12.7711 6.58567 13.333 8.00016 13.333ZM7.0815 5.60967L10.3342 7.77767C10.3707 7.80202 10.4007 7.83502 10.4215 7.87375C10.4422 7.91248 10.4531 7.95574 10.4531 7.99967C10.4531 8.04361 10.4422 8.08687 10.4215 8.1256C10.4007 8.16433 10.3707 8.19733 10.3342 8.22167L7.08083 10.3897C7.04072 10.4163 6.99415 10.4315 6.94608 10.4338C6.898 10.436 6.85021 10.4253 6.80777 10.4026C6.76533 10.3799 6.72982 10.3461 6.705 10.3049C6.68019 10.2637 6.667 10.2165 6.66683 10.1683V5.83101C6.66692 5.78277 6.68009 5.73547 6.70494 5.69413C6.72978 5.65279 6.76538 5.61896 6.80793 5.59625C6.85048 5.57354 6.89839 5.56279 6.94657 5.56516C6.99474 5.56752 7.04137 5.58291 7.0815 5.60967Z" fill="#1E1E25"/>
</svg>
);
export const WebsiteIcon=()=>(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.66683 14V15.3333H7.3335V14H2.00016C1.82335 14 1.65378 13.9298 1.52876 13.8047C1.40373 13.6797 1.3335 13.5101 1.3335 13.3333V2.66667C1.3335 2.48986 1.40373 2.32029 1.52876 2.19526C1.65378 2.07024 1.82335 2 2.00016 2H6.00016C6.37855 1.99955 6.75269 2.07984 7.09758 2.2355C7.44247 2.39116 7.75018 2.61861 8.00016 2.90267C8.25015 2.61861 8.55786 2.39116 8.90275 2.2355C9.24764 2.07984 9.62177 1.99955 10.0002 2H14.0002C14.177 2 14.3465 2.07024 14.4716 2.19526C14.5966 2.32029 14.6668 2.48986 14.6668 2.66667V13.3333C14.6668 13.5101 14.5966 13.6797 14.4716 13.8047C14.3465 13.9298 14.177 14 14.0002 14H8.66683ZM13.3335 12.6667V3.33334H10.0002C9.64654 3.33334 9.3074 3.47381 9.05735 3.72386C8.80731 3.97391 8.66683 4.31305 8.66683 4.66667V12.6667H13.3335ZM7.3335 12.6667V4.66667C7.3335 4.31305 7.19302 3.97391 6.94297 3.72386C6.69292 3.47381 6.35379 3.33334 6.00016 3.33334H2.66683V12.6667H7.3335Z" fill="#1E1E25"/>
</svg>
);
export const AircraftInformationIcon = () =>(
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_65794_8197)">
<path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z" fill="#1E1E25"/>
</g>
<defs>
<clipPath id="clip0_65794_8197">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

);
